module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card-list-item', {
    attrs: {
      "isModal": _vm.isModal,
      "itemImage": _vm.item.SCALENAME ? '/static/images/assess_icons/' + _vm.item.SCALENAME + '/icon.svg' : '/static/images/assess_icons/' + _vm.item.scaleName + '/icon.svg',
      "itemTitle": _vm.item.SCALENAME ? _vm.item.SCALENAME : _vm.item.scaleName,
      "showIndicator": _vm.item.selected
    },
    on: {
      "card-item-clicked": _vm.onTrainClicked
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "cart-item-title",
    class: {
      'cart-item-pic-mode': _vm.isModal
    }
  }, [_vm._v(_vm._s(_vm.item.SCALENAME ? _vm.item.SCALENAME : _vm.item.scaleName))])]), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "indicator",
      "value": "done",
      "color": "rgba(255, 255, 255, 0.6)",
      "size": 144
    },
    slot: "indicator"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9576c59e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bz/eval-card/component.vue
// module id = 1018
// module chunks = 2